import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
/* import snakecaseKeys from 'snakecase-keys'; */
import { Accordion, Col, Row } from 'react-bootstrap';
import { PayrollProcessContext } from '../../../RemunerationProcesses/context/PayrollProcessProvider';
import { sendAlert } from '../../../../actions/utils';
import { ComponentDataTable, DefaultModal, SimpleCenteredModal } from '../../../../components';
import {
  destroyReliquidationBalancesRequest,
  indexReliquidationBalancesRequest,
  massiveDestroyReliquidationBalancesRequest
  /* updateReliquidationBalancesRequest */
} from '../../../../requests/reliquidationBalances';
import Actions from './Actions';
import Filters from './Filters';
import Columns from './Columns';
import massiveActions from './MassiveActions';

const DEFAULT_MODAL = {
  title: '',
  body: <></>,
  show: false,
  action: function empty() {}
};
const ReliquidationBalancesTable = ({ setActiveComponent, onlyShow }) => {
  const dispatch = useDispatch();
  const { reliquidationProcess } = useContext(PayrollProcessContext);
  const [moreData, setMoreData] = useState(false);
  const [params, setParams] = useState({});
  const [balances, setBalances] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [modalState, setModalState] = useState({ ...DEFAULT_MODAL, disabled: false });
  const [simpleModalState, setSimpleModalState] = useState(DEFAULT_MODAL);
  const [onRequest, setOnRequest] = useState(false);
  const [amount, setAmount] = useState(0);
  const [filters, setFilters] = useState({});
  const [clearSelection, setClearSelection] = useState(false);

  const handleFilterAdvance = filterValues => {
    setFilters(filterValues);
    setParams(filterValues);
    setMoreData(!moreData);
  };

  const handleReliquidationBalances = _params => {
    setOnRequest(true);
    indexReliquidationBalancesRequest({
      dispatch,
      params: {
        ...filters,
        ..._params,
        sort_column: 'id',
        sort_direction: 'desc',
        filter_reliquidation_process_ids: reliquidationProcess.id
      },
      successCallback: ({ data }) => {
        setBalances(data.data);
        setAmount(data?.metadata?.amount);
      },
      callback: () => setOnRequest(false)
    });
  };

  const handleSelectedRows = rows => {
    const rowsObject = rows.selectedRows.map(row => row);
    setSelectedRows(rowsObject);
  };

  /* const handleBalanceUpdate = (id, values, setSubmitting) => {
    const data = snakecaseKeys(values);
    updateReliquidationBalancesRequest(id, {
      dispatch,
      params: data,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Concepto actualizado exitosamente!' }));
        setMoreData(!moreData);
        setSimpleModalState(oldState => ({ ...oldState, show: false }));
      },
      callback: () => setSubmitting(false)
    });
  }; */

  const handleBalanceDeactivate = id => {
    setOnRequest(true);
    setModalState(oldState => ({ ...oldState, disabled: true }));
    destroyReliquidationBalancesRequest(id, {
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Concepto eliminado exitosamente!' }));
        setMoreData(oldValue => !oldValue);
        setModalState(oldState => ({ ...oldState, show: false }));
      },
      failureCallback: () => {
        dispatch(sendAlert({ kind: 'error', message: 'No se pudo eliminar el concepto' }));
        setModalState(oldState => ({ ...oldState, show: false }));
        setOnRequest(false);
      },
      callback: () => {
        setClearSelection(true);
      }
    });
  };

  const handleMassiveDeactivate = () => {
    setOnRequest(true);
    setClearSelection(false);
    setModalState(oldState => ({ ...oldState, disabled: true }));
    massiveDestroyReliquidationBalancesRequest({
      dispatch,
      params: {
        ids: selectedRows.map(row => row.id)
      },
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Conceptos eliminado exitosamente!' }));
        setModalState(oldState => ({ ...oldState, show: false }));
        setMoreData(oldValue => !oldValue);
      },
      failureCallback: () => {
        dispatch(sendAlert({ kind: 'error', message: 'No se pudieron eliminar los conceptos' }));
        setModalState(oldState => ({ ...oldState, show: false }));
        setOnRequest(false);
      },
      callback: () => {
        setClearSelection(true);
      }
    });
  };

  const handleClick = (balance, action) => {
    switch (action) {
      case 'edit':
        setSimpleModalState({
          title: `Editar Concepto`,
          body: (
            <>
              <h1>Editar Concepto</h1>
            </>
            /* <EditBalanceForm
              payrollBalance={balance}
              payrollProcess={payrollProcess}
              formRequest={handleBalanceUpdate}
              handleModalClose={() => setSimpleModalState(modalState => ({ ...modalState, show: false }))}
            /> */
          ),
          show: true
        });
        break;
      case 'destroy':
        {
          const { id } = balance;
          setModalState({
            title: 'Eliminar Concepto',
            body: <p>¿Está seguro que desea eliminar el concepto?</p>,
            show: true,
            action: () => handleBalanceDeactivate(id)
          });
        }
        break;
      case 'massive_destroy':
        setModalState({
          title: 'Eliminar Conceptos',
          body: <p>¿Está seguro que desea eliminar los conceptos?</p>,
          show: true,
          action: () => handleMassiveDeactivate()
        });
        break;
      default:
        break;
    }
  };
  return (
    <>
      <Row className="mt-3 mb-3 ml-0 mr-0" style={{ position: 'relative', zIndex: '10' }}>
        <Actions
          setModalState={setModalState}
          setMoreData={setMoreData}
          params={params}
          setParams={setParams}
          setOnRequest={setOnRequest}
          setActiveComponent={setActiveComponent}
          setSimpleModalState={setSimpleModalState}
          onlyShow={onlyShow}
        />
      </Row>
      <Col>
        <Accordion defaultActiveKey="1" className="ml-2 mt-2 mr-2">
          <Filters formRequest={handleFilterAdvance} />
        </Accordion>
      </Col>
      <Col className="data-table-yellow">
        <ComponentDataTable
          onRequest={onRequest}
          columns={Columns(handleClick, onlyShow)}
          data={balances}
          totalRows={amount}
          moreData={moreData}
          resourceRequest={handleReliquidationBalances}
          onSelectedRowsChange={handleSelectedRows}
          clearSelectedRows={clearSelection}
          pointerOnHover
          selectableRows={!onlyShow}
          withMassActions={!onlyShow}
          withSearch={false}
          massActions={massiveActions(handleClick, selectedRows.length === 0 || reliquidationProcess.status !== 'open')}
        />
      </Col>
      <DefaultModal
        title={modalState.title}
        body={modalState.body}
        show={modalState.show}
        disabled={modalState.disabled}
        handleClose={() => setModalState(state => ({ ...state, disabled: false, show: false }))}
        handleConfirm={() => modalState.action()}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
      />
      <SimpleCenteredModal
        title={simpleModalState.title}
        body={simpleModalState.body}
        show={simpleModalState.show}
        onHide={() => setSimpleModalState(state => ({ ...state, show: false }))}
      />
    </>
  );
};

export default ReliquidationBalancesTable;
